import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

export interface Counter {
    오더접수: number;
    픽업예약: number;
    픽업완료: number;
    배송중: number;
    배송완료: number;
    company: string;
    month: string;
}

interface CounterResponse {
    statusCode: number;
    message: string;
    data: Counter;
}

export const useGetCounter = (): UseQueryResult<Counter, Error> => {
    return useQuery({
        queryKey: ["useGetCounter"],
        queryFn: async () => {
            const response = await axiosInstance.get<CounterResponse>(enum_api_uri.get_counter);
            return response.data.data;
        },
    });
};
